import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { fadeInAnimation } from '../_animations/fade-in.animation';
import { SessionService } from '../session/session.service';
import { PortalMode } from '../enum/portalmode.enum';

@Component({
    selector: 'app-more-info',
    templateUrl: './more-info.component.html',
    animations: [fadeInAnimation],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoreInfoComponent {
  public readonly textKey: string;
  public readonly borgenarTextKey: string;

  public get isBorgenarMode(): boolean {
    return this.sessionService.getPortalMode() === PortalMode.Borgenar;
  }

  public get logoSource(): string {
    switch (this.sessionService.getPortalMode()) {
      case PortalMode.Borgenar:
        return 'assets/img/borgenarsportal-logo.png';
      case PortalMode.Norge:
        return 'assets/img/lonnsgaranti-portal-logo.png';
      default:
        return 'assets/img/garanti-portal-logo.png';
    }
  }

  constructor(protected sessionService: SessionService, protected route: ActivatedRoute) {
    this.textKey = route.snapshot.data['textKey'];
    this.borgenarTextKey = route.snapshot.data['borgenarTextKey'];
  }
}
